<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.pickup"
        :primary-fields="[ 'booking_reference', 'carrier', 'consignments.con_full', 'sender', 'receiver', 'customer_reference', 'carrier_reference', 'status', 'customer_pickup_date' ]"
        :hidden-fields="[ 'account' ]"
        :setup-fields="{ customer_pickup_date: setupCustomerPickupDateFilterable }"
        @apply="reload"
        @ready="load"
      >
        <template v-slot:sender.input="{ filterable, apply }">
          <el-input
            v-model="filterable.filter.value"
            clearable
            size="small"
            class="w-100"
            @keyup.enter.native="apply"
          />
        </template>

        <template v-slot:receiver.input="{ filterable, apply }">
          <el-input
            v-model="filterable.filter.value"
            clearable
            size="small"
            class="w-100"
            @keyup.enter.native="apply"
          />
        </template>
      </Filters>
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <PickupsTable :pickups="pickups">
          <template v-slot:peek="{ pickup }">
            <PickupPeek :pickup="pickup" />
          </template>

          <template v-slot:reference="{ pickup }">
            <router-link :to="{ name: 'customerservice-accounts-account-pickups-pickup', params: { accountId: $route.params.accountId, pickupId: pickup.id } }">
              {{ pickup.booking_reference }}
            </router-link>
          </template>

          <template
            v-if="canUpdate"
            v-slot:actions="{ pickup }"
          >
            <el-dropdown
              split-button
              size="mini"
              trigger="click"
              @command="handleActionCommand"
              @click="canConfirmPickup(pickup) ? promptPickupConfirmationReference(pickup) : reBookPickup(pickup)"
            >
              {{ canConfirmPickup(pickup) ? 'Confirm' : 'Re-book' }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ action: promptPickupCancellationReason, pickup}"
                  :disabled="!canCancelPickup(pickup)"
                >
                  Cancel
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="canConfirmPickup(pickup)"
                  :command="{ action: reBookPickup, pickup}"
                >
                  Re-book
                </el-dropdown-item>

                <el-dropdown-item
                  :command="{ action: duplicatePickup, pickup}"
                >
                  Duplicate
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </PickupsTable>

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="pickups.page"
          :page-size.sync="pickups.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pickups.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import PickupsList from '@/views/Application/CustomerService/Pickups/List'
import Filter, { IS } from '@/plugins/sdk/Filter'
import { CREATE } from '@/plugins/user'

export default {
  extends: PickupsList,
  data () {
    return {
      actions: [
        {
          hidden: this.$user.cannot(CREATE, this.$sdk.pickup),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: async () => {
            const pickup = new this.$sdk.pickup()

            pickup.account = await this.$sdk.account.read(this.$route.params.accountId, request => {
              request.include = [
                'carrier_settings.carrier',
                'carrier_service_settings.carrier_service.carrier',
                'teams.shipper_setting.address'
              ]
            })
            pickup.customer_pickup_date = new Date()
            pickup.customer_ready_time = new Date()
            pickup.collection_name = 'DESPATCH'
            pickup.sender = new this.$sdk.address()
            pickup.receiver = new this.$sdk.address()
            pickup.items.push(new this.$sdk.pickup_item())

            this.createPickup(pickup)
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ]
    }
  },
  methods: {
    async load () {
      this.isLoading = true

      this.pickups = await this
        .$sdk
        .pickup
        .list(request => {
          request.filters = [
            new Filter('account', IS, this.$route.params.accountId),
            ...this.filters
          ]
          request.include = [
            'account',
            'carrier',
            'carrier_service',
            'profile',
            'items.type',
            'consignments.items.type'
          ]
          request.order = 'created_at:desc'
        })

      this.isLoading = false
    },
    async reload () {
      this.isLoading = true

      await this
        .pickups
        .reload(request => {
          request.filters = [
            new Filter('account', IS, this.$route.params.accountId),
            ...this.filters
          ]
        })

      this.isLoading = false
    }
  }
}
</script>
